exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notification-circle-icon[data-v-75682efa] {\n  background-color: red;\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  line-height: 16px;\n  font-size: 12px;\n  text-align: center;\n  margin: auto 0px;\n}\n.icon-news-for-osaka[data-v-75682efa] {\n  display: flex;\n}\n", ""]);

// exports
